import { jsxs, jsx } from 'react/jsx-runtime';
import './PaymentTab.module.scss.js';
import classNames from 'classnames';
import { P2, P1 } from '@zooplus/ui-components';
import StateBox from '../../../components/StateBox/StateBox.js';
import PaymentLogo from '../PaymentLogo/PaymentLogo.js';
import { useTranslation } from '../../../hooks/useTranslations.js';

const pm_text = {
    K: 'general.payment.credit_card',
    CD: 'general.payment.cashondelivery',
    KL: 'general.payment.KL.name',
    KO: 'general.payment.KO.name',
    R: 'general.payment.invoice',
    VK: 'payment.prepaired.description',
    TY: 'Instant bank payment',
};
const PaymentTab = ({ paymentMethod, className, url, variant = 'default', title, onClick, }) => {
    const { t } = useTranslation();
    return (jsxs(StateBox, { variant: variant, className: classNames({ paymentTabTitle: title }, className, 'paymentTab'), dataZta: "paymentTab", onClick: onClick, children: [jsx(PaymentLogo, { className: 'tabLogo', method: paymentMethod, url: url }), !url && paymentMethod && pm_text[paymentMethod] && (jsx(P2, { className: "paymentTabTitle", children: t(pm_text[paymentMethod]) })), title && jsx(P1, { className: "paymentTabSecondTitle", children: title })] }));
};

export { PaymentTab as default, pm_text };
//# sourceMappingURL=PaymentTab.js.map
